import React, { Component, useEffect, useState } from 'react';
import { render } from 'react-dom';
import { Line } from 'react-chartjs-2';
import Chart from 'chart.js/auto';
import moment from 'moment';

const ValidateColor = (processValue) => {

  let status;
  if( processValue >= 90 ) {
      // Green
      status = 'rgba(60,196,128, 0.4)';
  } else if( processValue > 60 && processValue < 90 ) {
      // Yellow
      status = 'rgba(255,198,10, 0.4)';
  } else if( processValue <= 60 ) {
      // Red
      status = 'rgba(255,85,68, 0.4)';
  }

  return status;

}

const LineChart = ({ lineChartData, lineGraphData, name, options, chartColor }) => {

  let processValue = parseInt(lineChartData.value);
  let processColor = ValidateColor(processValue);

  const [lineData, SetLineData] = useState({
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
    datasets: [
      {
        fill: true,
        borderColor: chartColor ? chartColor :processColor,
        borderWidth: 1
      }
    ]
  });
  const [isUpdated, SetIsUpdated] = useState(false);

  useEffect(() => {

      let LineChartPoints = [], lables = [];
      
      if(lineGraphData === null || lineGraphData === undefined) return false;
      
      if( (typeof lineGraphData[0] === "object" || typeof lineGraphData[0] === 'function') && (lineGraphData[0] !== null) ) {
        lineGraphData && lineGraphData.map((item, index) => {
          LineChartPoints.push(item.value);
          lables.push(moment(new Date(item.ts)).utc().format('h:mm:ss A'));
        });

        var ctx = document.getElementById('canvas').getContext("2d");
        var gradient = ctx.createLinearGradient(0, 0, 0, 400)
        gradient.addColorStop(0, chartColor ? chartColor :processColor);
        gradient.addColorStop(0.50, '#ffffff');


      } else {
        LineChartPoints = lineGraphData;
        lables = ["Mon", "Tue", "Wed", "Thu", "Fri"];

        var ctx = document.getElementById('canvas').getContext("2d");
        var gradient = ctx.createLinearGradient(0, 0, 0, 400)
        gradient.addColorStop(0, chartColor ? chartColor :processColor);
        gradient.addColorStop(0.5, '#ffffff');
        gradient.addColorStop(0.18, '#ffffff');
      }

    SetLineData({
      labels: lables,
      datasets: [
        {
          data: LineChartPoints,
          fill: true,
          backgroundColor: gradient,
          borderColor: processColor,
          borderWidth: 1
        }
      ]
    });
    SetIsUpdated(true);


  }, [ lineChartData, lineGraphData ]);

  return <div className='line-chart-container' key={ isUpdated }>
              { lineData && <Line id='canvas' data={lineData} options={ options}  /> }
        </div>

};

export default LineChart;